var exports = {
  "k": "x14bf3cd8--4c4e1a--container",
};

module.exports = exports;
